import type {
  DecodedBrowserAppointment,
  ParticipantAppointment,
  ParticipantAppointmentDetail,
} from './types';

export type AppointmentParticipantRole = 'member' | 'coach';

const normalizedPersonId = (personId: string | null | undefined) => {
  const normalized = personId?.trim().toLowerCase();
  return normalized || null;
};

export const resolveAppointmentParticipantRole = (
  appointment:
    | DecodedBrowserAppointment
    | ParticipantAppointment
    | ParticipantAppointmentDetail,
  viewerPersonId: string | null | undefined,
): AppointmentParticipantRole | null => {
  const viewer = normalizedPersonId(viewerPersonId);
  if (!viewer) return null;

  const memberMatches =
    viewer ===
    normalizedPersonId(appointment.expectedIdentities.member.personId);
  const coachMatches =
    viewer ===
    normalizedPersonId(appointment.expectedIdentities.coach.personId);

  if (memberMatches === coachMatches) return null;
  return memberMatches ? 'member' : 'coach';
};
